(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crs-customer-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(root) {
    var track = root.querySelector('[data-cr-track]');
    var out = root.querySelector('[data-cr-progress-current]');
    if (!track || !out || track.__crBound) return;
    track.__crBound = true;

    var prev = root.querySelector('[data-cr-prev]');
    var next = root.querySelector('[data-cr-next]');

    // Schrittweite = eine Karte plus Gap. Aus dem DOM gelesen statt aus dem CSS
    // gespiegelt, damit die drei Breakpoints der Kartenformel nicht zweimal
    // gepflegt werden muessen.
    function step() {
      var cards = track.children;
      if (cards.length < 2) return track.clientWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    var raf = null;
    function update() {
      raf = null;
      var cards = track.children;
      if (!cards.length) return;
      var mid = track.scrollLeft + track.clientWidth / 2;
      var idx = 0;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        if (c.offsetLeft <= mid && c.offsetLeft + c.offsetWidth > mid) { idx = i; break; }
        if (c.offsetLeft <= mid) idx = i;
      }
      out.textContent = String(idx + 1);

      // 1px Toleranz: scrollLeft ist bei fraktionalen Kartenbreiten nicht ganzzahlig.
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    track.addEventListener('scroll', function () {
      if (raf === null) raf = requestAnimationFrame(update);
    }, { passive: true });

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    update();
  }

  function init() {
    document.querySelectorAll('.cr-section, [id^="shopify-section"]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crs-faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__crsFaqAccordionBound) return;
  window.__crsFaqAccordionBound = true;

  function panelById(root, id) {
    if (!id) return null;
    var el = document.getElementById(id);
    return el && root.contains(el) ? el : null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.faq-section .faq-question');
    if (!btn) return;

    var section = btn.closest('.faq-section');
    if (!section) return;

    var buttons = section.querySelectorAll('.faq-question');
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    var panelId = btn.getAttribute('aria-controls');
    var panel = panelById(section, panelId);

    buttons.forEach(function (other) {
      if (other !== btn) {
        other.setAttribute('aria-expanded', 'false');
        var otherId = other.getAttribute('aria-controls');
        var otherPanel = panelById(section, otherId);
        if (otherPanel) otherPanel.classList.remove('is-open');
      }
    });

    /* Der Chevron dreht sich per CSS über [aria-expanded]. Kein Zeichentausch. */
    if (!expanded) {
      btn.setAttribute('aria-expanded', 'true');
      if (panel) panel.classList.add('is-open');
    } else {
      btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.classList.remove('is-open');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crs-knowledge-base"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindHotspots(graph) {
      if (!graph || graph.dataset.hotspotsBound === 'true') return;

      var hotspots = graph.querySelectorAll('[data-nad-hotspot]');

      function closeAll(except) {
        hotspots.forEach(function (hotspot) {
          var expanded = except && hotspot === except;
          hotspot.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      }

      hotspots.forEach(function (hotspot) {
        hotspot.addEventListener('click', function (event) {
          event.stopPropagation();
          var isOpen = hotspot.getAttribute('aria-expanded') === 'true';
          closeAll(isOpen ? null : hotspot);
        });
      });

      graph.addEventListener('click', function () {
        closeAll(null);
      });

      graph.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        closeAll(null);
      });

      graph.dataset.hotspotsBound = 'true';
    }

    function setupGraph(graph) {
      if (!graph || graph.dataset.graphReady === 'true') return;

      var line = graph.querySelector('.ckb-nad__line');
      if (line) {
        var length = line.getTotalLength();
        line.style.strokeDasharray = length;
        line.style.strokeDashoffset = length;
        graph.style.setProperty('--ckb-nad-path-length', length);
      }

      graph.dataset.graphReady = 'true';
    }

    function observeGraph(graph) {
      if (!graph || graph.dataset.graphObserved === 'true') return;
      graph.dataset.graphObserved = 'true';

      function play() {
        if (graph.dataset.graphPlayed === 'true') return;
        graph.dataset.graphPlayed = 'true';
        graph.classList.add('is-visible');

        window.setTimeout(function () {
          graph.classList.add('is-complete');
        }, 2600);
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        play();
        graph.classList.remove('is-complete');
        return;
      }

      if (!('IntersectionObserver' in window)) {
        play();
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          play();
          observer.unobserve(entry.target);
        });
      }, {
        threshold: 0.18,
        rootMargin: '0px 0px -8% 0px'
      });

      observer.observe(graph);
    }

    function init(root) {
      var scope = root || document;
      var graphs = scope.querySelectorAll('[data-ckb-nad-graph]');

      graphs.forEach(function (graph) {
        setupGraph(graph);
        bindHotspots(graph);
        observeGraph(graph);
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tocs = document.querySelectorAll('[data-lt-toc]');
  if (!tocs.length) return;

  Array.prototype.forEach.call(tocs, function (toc) {
    toc.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', link.getAttribute('href'));
      // Nur die aufklappbare Variante schließt sich nach dem Sprung.
      if (toc.tagName === 'DETAILS') toc.removeAttribute('open');
    });
  });

  // Scroll-Spy: hebt in der Sidebar den Abschnitt hervor, der gerade gelesen wird.
  var rail = document.querySelector('.lt-article__toc-rail');
  if (!rail || !('IntersectionObserver' in window)) return;

  var links = rail.querySelectorAll('a[href^="#abschnitt-"]');
  if (!links.length) return;

  var linkFor = {};
  var targets = [];
  Array.prototype.forEach.call(links, function (link) {
    var el = document.getElementById(link.getAttribute('href').slice(1));
    if (!el) return;
    linkFor[el.id] = link;
    targets.push(el);
  });
  if (!targets.length) return;

  var visible = {};
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting;
      });

      var current = null;
      targets.forEach(function (el) {
        if (!current && visible[el.id]) current = el.id;
      });
      // Zwischen zwei Abschnitten ist nichts sichtbar — dann bleibt die
      // letzte Markierung stehen, statt kurz ganz zu verschwinden.
      if (!current) return;

      Array.prototype.forEach.call(links, function (link) {
        link.removeAttribute('aria-current');
      });
      if (linkFor[current]) linkFor[current].setAttribute('aria-current', 'true');
    },
    { rootMargin: '-96px 0px -70% 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-blog-index"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-lt-blog-more]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      button.setAttribute('aria-busy', 'true');

      fetch(button.href)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-lt-blog-grid]');
          var grid = button.closest('.lt-blog-index').querySelector('[data-lt-blog-grid]');
          if (newGrid && grid) {
            while (newGrid.firstElementChild) {
              grid.appendChild(newGrid.firstElementChild);
            }
          }
          var nextButton = doc.querySelector('[data-lt-blog-more]');
          if (nextButton) {
            button.href = nextButton.href;
            button.removeAttribute('aria-busy');
          } else {
            button.parentElement.remove();
          }
        })
        .catch(function () {
          // Fallback: normal navigieren, wenn fetch scheitert
          window.location.href = button.href;
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tocs = document.querySelectorAll('[data-lt-guide-toc]');
  if (!tocs.length) return;

  Array.prototype.forEach.call(tocs, function (toc) {
    toc.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var target = document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1)));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', link.getAttribute('href'));
      // Nur die aufklappbare Variante schließt sich nach dem Sprung.
      if (toc.tagName === 'DETAILS') toc.removeAttribute('open');
    });
  });

  // Scroll-Spy: hebt in der Rail das Kapitel hervor, das gerade gelesen wird.
  var rail = document.querySelector('.lt-guide__toc-rail');
  if (!rail || !('IntersectionObserver' in window)) return;

  var links = rail.querySelectorAll('a[href^="#"]');
  if (!links.length) return;

  var linkFor = {};
  var targets = [];
  Array.prototype.forEach.call(links, function (link) {
    var el = document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1)));
    if (!el) return;
    linkFor[el.id] = link;
    targets.push(el);
  });
  if (!targets.length) return;

  var visible = {};
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting;
      });

      var current = null;
      targets.forEach(function (el) {
        if (!current && visible[el.id]) current = el.id;
      });
      // Zwischen zwei Kapiteln ist nichts sichtbar. Dann bleibt die letzte
      // Markierung stehen, statt kurz ganz zu verschwinden.
      if (!current) return;

      Array.prototype.forEach.call(links, function (link) {
        link.removeAttribute('aria-current');
      });
      if (linkFor[current]) linkFor[current].setAttribute('aria-current', 'true');
    },
    { rootMargin: '-96px 0px -70% 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-hp-bekannt"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.ltlInit) return;
    root.dataset.ltlInit = '1';
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = root.getBoundingClientRect();
    /* Schon im Blick (z. B. nach Reload mitten auf der Seite): nicht verstecken, nichts animieren */
    if (r.top < window.innerHeight && r.bottom > 0) return;
    root.classList.add('ltl--bereit');
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        root.classList.add('ltl--sichtbar');
        io.disconnect();
      });
    }, { threshold: 0.4 });
    io.observe(root);
  }
  function alle() { document.querySelectorAll('[data-ltl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-ltl]');
    if (r) { delete r.dataset.ltlInit; r.classList.remove('ltl--bereit', 'ltl--sichtbar'); init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-hp-bereiche"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ltBereicheBound) return;
  window.__ltBereicheBound = true;

  function waehle(root, i, merken) {
    var tabs = root.querySelectorAll('.ltb__tab');
    if (!tabs[i]) return;
    tabs.forEach(function (t, k) {
      var an = k === i;
      t.classList.toggle('is-active', an);
      t.setAttribute('aria-selected', an ? 'true' : 'false');
      t.setAttribute('tabindex', an ? '0' : '-1');
    });
    root.querySelectorAll('.ltb__img').forEach(function (img, k) {
      img.classList.toggle('is-active', k === i);
    });
    root.querySelectorAll('.ltb__panel').forEach(function (p, k) {
      p.classList.toggle('is-active', k === i);
    });
    if (merken && tabs[i].dataset.handle && window.history && history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('bereich', tabs[i].dataset.handle);
      u.hash = 'bereiche';
      history.replaceState(null, '', u);
    }
  }

  function start(root) {
    if (!root || root.__ltbStart) return;
    root.__ltbStart = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.ltb__tab'));
    var wunsch = new URLSearchParams(window.location.search).get('bereich');
    if (wunsch) {
      tabs.forEach(function (t, k) { if (t.dataset.handle === wunsch) waehle(root, k, false); });
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('.ltb__tab');
      if (t) waehle(root, tabs.indexOf(t), true);
    });
    root.addEventListener('keydown', function (e) {
      var t = e.target.closest('.ltb__tab');
      if (!t) return;
      var i = tabs.indexOf(t), n = tabs.length, ziel = null;
      if (e.key === 'ArrowRight') ziel = (i + 1) % n;
      else if (e.key === 'ArrowLeft') ziel = (i - 1 + n) % n;
      else if (e.key === 'Home') ziel = 0;
      else if (e.key === 'End') ziel = n - 1;
      if (ziel === null) return;
      e.preventDefault();
      waehle(root, ziel, true);
      tabs[ziel].focus();
    });
  }

  function alle() { document.querySelectorAll('[data-ltb]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', function (e) { start(e.target.querySelector('[data-ltb]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-hp-hero-vollbild"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lthvInit) return;
    root.dataset.lthvInit = '1';
    var spur = root.querySelector('[data-lthv-spur]');
    var folien = spur ? spur.children : [];
    var punkte = root.querySelectorAll('[data-lthv-ziel]');
    var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Kopfzeile liegt absolut über dem Hero: Papier-Streifen oben auf ihre echte Höhe setzen */
    var kopf = document.querySelector('.site-header');
    function messeKopf() {
      if (kopf && kopf.offsetHeight) root.style.setProperty('--lthv-kopf', kopf.offsetHeight + 'px');
    }
    messeKopf();
    window.addEventListener('resize', messeKopf, { passive: true });

    if (!spur || folien.length < 2) return;
    function aktuell() { return Math.round(spur.scrollLeft / spur.clientWidth); }
    function zu(i) {
      i = (i + folien.length) % folien.length;
      spur.scrollTo({ left: folien[i].offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
    }
    function markiere() {
      var i = aktuell();
      punkte.forEach(function (p, k) { p.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    punkte.forEach(function (p) { p.addEventListener('click', function () { zu(+p.dataset.lthvZiel); }); });
    root.querySelectorAll('[data-lthv-richtung]').forEach(function (b) {
      b.addEventListener('click', function () { zu(aktuell() + (+b.dataset.lthvRichtung)); });
    });
    spur.addEventListener('scroll', function () { window.requestAnimationFrame(markiere); }, { passive: true });
  }
  function alle() { document.querySelectorAll('[data-lthv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-lthv]');
    if (r) { delete r.dataset.lthvInit; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-hp-stimmen"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ltStimmenBound) return;
  window.__ltStimmenBound = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.ltk__pfeile button');
    if (!b) return;
    var root = b.closest('[data-ltk]');
    var spur = root && root.querySelector('.ltk__spur');
    var karte = spur && spur.querySelector('.ltk__karte');
    if (!karte) return;
    var schritt = karte.getBoundingClientRect().width + 16;
    var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    spur.scrollBy({ left: (+b.dataset.r) * schritt, behavior: ruhig ? 'auto' : 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-hp-video-vsl"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ltVslBound) return;
  window.__ltVslBound = true;

  /* YouTube erst nach Klick laden (youtube-nocookie), vorher keine Anfrage an Google. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ltvsl__play');
    if (!btn) return;
    var player = btn.closest('[data-ltvsl-video]');
    if (!player) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(player.dataset.ltvslVideo) + '?autoplay=1&playsinline=1&rel=0';
    f.title = player.dataset.ltvslTitle || 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture';
    f.allowFullscreen = true;
    player.innerHTML = '';
    player.classList.add('is-playing');
    player.appendChild(f);
    f.focus();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-nad-age-graph"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function escapeSvgText(text) {
      return String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function normalizeNumber(value) {
      return Number(String(value || '').replace(',', '.'));
    }

    function formatNumber(value) {
      var rounded = Math.round(value * 100) / 100;
      return rounded % 1 === 0 ? String(rounded.toFixed(0)) : String(rounded.toFixed(2)).replace(/0+$/, '').replace(/\.$/, '');
    }

    function buildGraph(section) {
      var svg = section.querySelector('.nad-graph__svg');
      var line = section.querySelector('[data-nad-graph-line]');
      var area = section.querySelector('[data-nad-graph-area]');
      var markers = section.querySelector('[data-nad-graph-markers]');
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-point]'));
      var xMax = Number(section.dataset.xMax || 80);
      var yMax = Number(section.dataset.yMax || 10);

      if (!svg || !line || !area || !markers || cards.length < 2 || !xMax || !yMax) return;

      var plot = {
        left: 96,
        right: 960,
        top: 68,
        bottom: 440
      };

      var width = plot.right - plot.left;
      var height = plot.bottom - plot.top;
      var points = cards.map(function (card) {
        return {
          element: card,
          stage: card.querySelector('.nad-graph__card-kicker') ? card.querySelector('.nad-graph__card-kicker').textContent.trim() : '',
          ageLabel: card.querySelector('.nad-graph__age') ? card.querySelector('.nad-graph__age').textContent.trim() : '',
          value: normalizeNumber(card.dataset.value || 0),
          age: normalizeNumber(card.dataset.age || 0)
        };
      }).filter(function (point) {
        return !Number.isNaN(point.value) && !Number.isNaN(point.age);
      });

      var commands = [];
      var areaCommands = [];

      markers.innerHTML = '';

      points.forEach(function (point, index) {
        var x = plot.left + (point.age / xMax) * width;
        var y = plot.bottom - (point.value / yMax) * height;
        point.x = Math.max(plot.left, Math.min(plot.right, x));
        point.y = Math.max(plot.top, Math.min(plot.bottom, y));

        commands.push((index === 0 ? 'M ' : 'L ') + point.x.toFixed(2) + ' ' + point.y.toFixed(2));

        if (index === 0) {
          areaCommands.push('M ' + point.x.toFixed(2) + ' ' + plot.bottom);
          areaCommands.push('L ' + point.x.toFixed(2) + ' ' + point.y.toFixed(2));
        } else {
          areaCommands.push('L ' + point.x.toFixed(2) + ' ' + point.y.toFixed(2));
        }

        var group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        var delay = (index * 0.16 + 0.42).toFixed(2) + 's';
        var anchor = 'middle';
        var labelX = point.x;

        if (index === 0) {
          anchor = 'start';
          labelX = point.x + 18;
        } else if (index === points.length - 1) {
          anchor = 'end';
          labelX = point.x - 18;
        }

        var labelY = point.y - 26;
        if (point.y < plot.top + 54) labelY = point.y + 54;

        group.setAttribute('class', 'nad-graph__marker');
        group.style.animationDelay = delay;

        group.innerHTML =
          '<circle class="nad-graph__marker-glow" cx="' + point.x.toFixed(2) + '" cy="' + point.y.toFixed(2) + '" r="26"></circle>' +
          '<circle class="nad-graph__marker-ring" cx="' + point.x.toFixed(2) + '" cy="' + point.y.toFixed(2) + '" r="12"></circle>' +
          '<circle class="nad-graph__marker-core" cx="' + point.x.toFixed(2) + '" cy="' + point.y.toFixed(2) + '" r="5"></circle>' +
          '<text class="nad-graph__marker-label" text-anchor="' + anchor + '" x="' + labelX.toFixed(2) + '" y="' + labelY.toFixed(2) + '">' + escapeSvgText(formatNumber(point.value)) + '</text>' +
          '<text class="nad-graph__marker-copy" text-anchor="' + anchor + '" x="' + labelX.toFixed(2) + '" y="' + (labelY + 26).toFixed(2) + '">' + escapeSvgText(point.stage) + '</text>';

        markers.appendChild(group);
      });

      areaCommands.push('L ' + points[points.length - 1].x.toFixed(2) + ' ' + plot.bottom);
      areaCommands.push('Z');

      line.setAttribute('d', commands.join(' '));
      area.setAttribute('d', areaCommands.join(' '));

      var length = line.getTotalLength();
      line.style.strokeDasharray = length;
      line.style.strokeDashoffset = length;
      section.style.setProperty('--nad-graph-path-length', length);
    }

    function observe(section) {
      if (section.__nadGraphObserved) return;
      section.__nadGraphObserved = true;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.classList.add('is-visible');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, {
        threshold: 0.3
      });

      observer.observe(section);
    }

    function init(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('[data-nad-graph]');

      sections.forEach(function (section) {
        buildGraph(section);
        observe(section);
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-page-whats-inside-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeDnaMore(root) {
      var stacks = root.querySelectorAll('[data-dna-stack]');
      stacks.forEach(function (stack) {
        var button = stack.querySelector('[data-dna-more]');
        if (!button || button.dataset.dnaMoreReady === 'true') return;

        button.addEventListener('click', function () {
          stack.classList.add('is-expanded');
          button.setAttribute('aria-expanded', 'true');
          var firstExtra = stack.querySelector('[data-dna-first-extra]');
          if (firstExtra) firstExtra.focus({ preventScroll: true });
        });

        button.dataset.dnaMoreReady = 'true';
      });
    }

    function initializeInsideTabs(root) {
      if (!root || root.dataset.insideTabsReady === 'true') return;

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-inside-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-inside-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;

      function activateTab(nextTab, shouldFocus) {
        if (!nextTab) return;

        tabs.forEach(function (tab, index) {
          var isActive = tab === nextTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
          panels[index].classList.toggle('is-active', isActive);
          panels[index].hidden = !isActive;
        });

        if (shouldFocus) nextTab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(tab, false);
        });

        tab.addEventListener('keydown', function (event) {
          var targetIndex = null;

          if (event.key === 'ArrowRight') {
            targetIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft') {
            targetIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            targetIndex = 0;
          } else if (event.key === 'End') {
            targetIndex = tabs.length - 1;
          }

          if (targetIndex === null) return;

          event.preventDefault();
          activateTab(tabs[targetIndex], true);
        });
      });

      initializeDnaMore(root);
      root.dataset.insideTabsReady = 'true';
    }

    function initializeAllInsideTabs(container) {
      var scope = container || document;
      var roots = scope.querySelectorAll('[data-inside-tabs-root]');
      roots.forEach(function (root) {
        initializeInsideTabs(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAllInsideTabs(document);
      }, { once: true });
    } else {
      initializeAllInsideTabs(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAllInsideTabs(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-pdp-reviews-all"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ltraBound) return;
  window.__ltraBound = true;

  var HASH = '#reviews';

  function openTarget() {
    var el = document.querySelector('[data-ltra]' + HASH);
    if (el && !el.open) el.open = true;
    return el;
  }

  function fromHash() {
    if (window.location.hash === HASH) openTarget();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fromHash);
  } else {
    fromHash();
  }
  window.addEventListener('hashchange', fromHash);
  document.addEventListener('pointerdown', function (e) {
    var s = e.target.closest('.ltra__summary');
    if (s) s.setAttribute('data-ltra-pointer', '');
  });
  document.addEventListener('keydown', function () {
    document.querySelectorAll('.ltra__summary[data-ltra-pointer]').forEach(function (s) {
      s.removeAttribute('data-ltra-pointer');
    });
  });

  /* Links auf derselben Seite: vor der Navigation öffnen, damit der Sprung
     auf der aufgeklappten Section landet. Steht der Hash schon in der URL,
     feuert kein hashchange, dann scrollt der Handler selbst. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="' + HASH + '"]');
    if (!a || a.hash !== HASH || a.pathname !== window.location.pathname) return;
    var el = openTarget();
    if (el && window.location.hash === HASH) {
      e.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-science-scope"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var bodies = document.querySelectorAll('.scp__body');
    if (!bodies.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var body = entry.target;
          io.unobserve(body);
          body.classList.add('scp-in');
          var num = body.querySelector('[data-scp-count]');
          if (num) {
            var target = parseInt(num.getAttribute('data-scp-count'), 10);
            var t0 = null;
            var step = function (ts) {
              if (t0 === null) t0 = ts;
              var p = Math.min((ts - t0) / 900, 1);
              var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
              num.textContent = Math.round(target * eased);
              if (p < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
          }
        });
      },
      { threshold: 0.4 }
    );

    bodies.forEach(function (body) {
      body.querySelectorAll('.scp__example').forEach(function (chip, i) {
        chip.style.setProperty('--scp-d', i * 45 + 'ms');
      });
      var numEl = body.querySelector('.scp__number');
      if (numEl) {
        var val = numEl.textContent.trim();
        if (/^\d+$/.test(val)) {
          numEl.innerHTML =
            '<span aria-hidden="true" data-scp-count="' + val + '">' + val + '</span>' +
            '<span class="visually-hidden">' + val + '</span>';
        }
      }
      body.classList.add('scp-ready');
      io.observe(body);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-science-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var medias = document.querySelectorAll('.lts__media-svg');
    if (!medias.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sci-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );
    medias.forEach(function (media) {
      media.classList.add('sci-ready');
      io.observe(media);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-wiss-hero"] && !Shopify.designMode) return;
  try {
    
  /*
    Vorher-Nachher-Wipe.
    Der range-Input liegt unsichtbar ueber der ganzen Flaeche, deshalb bedienen
    Maus, Touch und Tastatur (Pfeiltasten, Pos1/Ende) denselben Wert; es gibt
    keinen zweiten Eingabepfad, den man synchron halten muesste.

    prefers-reduced-motion: das Bauteil bewegt sich nur, solange jemand es
    zieht. Es gibt keine Transition, keinen Auto-Play und keine Einblend-
    Animation, also auch nichts zu unterdruecken. Wer hier spaeter eine
    Transition ergaenzt, muss sie gegen die Media Query stellen.

    Custom Element statt DOMContentLoaded-Handler: so greift der Upgrade auch
    nach `shopify:section:load` im Theme-Editor, ohne Re-Init-Listener.
  */
  if (!customElements.get('lt-wiss-wipe')) {
    customElements.define(
      'lt-wiss-wipe',
      class LtWissWipe extends HTMLElement {
        connectedCallback() {
          var frame = this.querySelector('.ltw-ba');
          var range = this.querySelector('.ltw-ba__range');
          if (!frame || !range) return;
          var apply = function () {
            frame.style.setProperty('--ltw-ba-pos', range.value + '%');
          };
          range.addEventListener('input', apply);
          apply();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmn-pdp-v2-benefit-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wireDialog(root) {
      if (!root || root.dataset.nmn2BenefitDlgReady === 'true') return;
      root.dataset.nmn2BenefitDlgReady = 'true';

      root.querySelectorAll('[data-nmn2-benefit-source-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('aria-controls');
          var dlg = id ? document.getElementById(id) : null;
          if (!dlg || typeof dlg.showModal !== 'function') return;
          dlg._nmnTrigger = btn;
          dlg.showModal();
          var titleEl = dlg.querySelector('.nmn2-benefit-strip__dialog-title');
          if (titleEl && typeof titleEl.focus === 'function') titleEl.focus();
        });
      });

      root.querySelectorAll('.nmn2-benefit-strip__dialog').forEach(function (dlg) {
        dlg.addEventListener('click', function (e) {
          if (e.target === dlg) dlg.close();
        });
        dlg.addEventListener('close', function () {
          var t = dlg._nmnTrigger;
          if (t && typeof t.focus === 'function') t.focus();
          dlg._nmnTrigger = null;
        });
        dlg.querySelectorAll('[data-nmn2-benefit-source-close]').forEach(function (closeBtn) {
          closeBtn.addEventListener('click', function () {
            dlg.close();
          });
        });
      });
    }

    document.querySelectorAll('[data-nmn2-benefit-strip]').forEach(wireDialog);
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-nmn2-benefit-strip]');
      if (r) wireDialog(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmn-pdp-v2-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.nmn2FaqReady === 'true') return;
      root.dataset.nmn2FaqReady = 'true';

      root.querySelectorAll('[data-nmn2-faq-trigger]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-nmn2-faq-item]');
          if (!item) return;
          var wasOpen = item.classList.contains('is-open');

          root.querySelectorAll('[data-nmn2-faq-item]').forEach(function (i) {
            i.classList.remove('is-open');
            var b = i.querySelector('[data-nmn2-faq-trigger]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });

          if (!wasOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    document.querySelectorAll('[data-nmn2-faq]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-nmn2-faq]');
      if (r) init(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmn-pdp-v2-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var observer = null;

    function disconnectStickyObserver() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }

    function initStickyBar(root) {
      if (!root) return;
      disconnectStickyObserver();

      var heroBtn = document.getElementById('hero-cta-button');
      var body = document.body;

      function setBarVisible(show) {
        root.classList.toggle('nmn2-sticky-bar--visible', show);
        root.setAttribute('aria-hidden', show ? 'false' : 'true');
        body.classList.toggle('nmn2-sticky-bar-active', show);
      }

      setBarVisible(false);

      if (!heroBtn || !('IntersectionObserver' in window)) return;

      observer = new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          setBarVisible(!e.isIntersecting);
        },
        { root: null, threshold: 0, rootMargin: '0px' }
      );
      observer.observe(heroBtn);
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-nmn-v2-sticky-bar-submit]');
      if (!t) return;
      var hero = document.getElementById('hero-cta-button');
      if (!hero || hero.disabled || hero.classList.contains('disabled')) return;
      hero.click();
    });

    document.querySelectorAll('[data-nmn-v2-sticky-bar]').forEach(initStickyBar);

    document.addEventListener('shopify:section:load', function (e) {
      var sticky = document.querySelector('[data-nmn-v2-sticky-bar]');
      if (sticky && e.target.querySelector && e.target.querySelector('#hero-cta-button')) {
        initStickyBar(sticky);
      }
      var r = e.target.querySelector('[data-nmn-v2-sticky-bar]');
      if (r) initStickyBar(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nmn-pdp-v2-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setActive(dots, index) {
      dots.forEach(function (d, j) {
        d.setAttribute('aria-current', j === index ? 'true' : 'false');
      });
    }

    function init(root) {
      if (!root || root.dataset.nmn2TimelineReady === 'true') return;
      root.dataset.nmn2TimelineReady = 'true';

      var scroller = root.querySelector('[data-nmn2-timeline-scroller]');
      var cards = root.querySelectorAll('[data-nmn2-timeline-card]');
      var dots = root.querySelectorAll('[data-nmn2-timeline-dot]');
      if (!scroller || !cards.length || !dots.length) return;

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          var card = cards[i];
          if (card) {
            card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
            setActive(dots, i);
          }
        });
      });

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var idx = parseInt(entry.target.getAttribute('data-nmn2-timeline-index'), 10);
              if (!isNaN(idx)) setActive(dots, idx);
            });
          },
          { root: scroller, threshold: 0.55 }
        );
        cards.forEach(function (c) {
          observer.observe(c);
        });
      }
    }

    document.querySelectorAll('[data-nmn2-timeline]').forEach(init);
    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target.querySelector('[data-nmn2-timeline]');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
